/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect, forwardRef, useImperativeHandle} from 'react'
import {useCrud} from '../../../services/loggedin/CrudContext'
import {ActionType, ColumnType, DefaultMenuActions, FilterType} from './Types'
import {format, set} from 'date-fns'
import {NumericFormat} from 'react-number-format'
import {MenuComponent} from '../../../_metronic/assets/ts/components'
import {Link, Navigate, useParams} from 'react-router-dom'
import clsx from 'clsx'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

export const ListComponent = forwardRef((props:any,ref) => {

  useImperativeHandle(ref, () => ({
    forceReload() {
      setReloadData(reloadData + 1)
    }
  }));
  const {columns, defOrder, defOrderDir} = props
  let actions: ActionType[] = DefaultMenuActions
  if (props.actions) {
    actions = props.actions
  }

  const newButton = props.newButton !== undefined ? props.newButton : true
  let _filters: FilterType[] = props.filters !== undefined ? props.filters : []

  let show_menu: boolean = props.show_menu !== undefined ? props.show_menu : true
  let per_page = props.perPage !== undefined ? props.perPage : 10
  let title_delete = props.title_delete !== undefined ? props.title_delete : "Eliminare l'elemento?"
  let text_eliminare =
    props.text_eliminare !== undefined
      ? props.text_eliminare
      : "Sei sicuro di voler eliminare l'elemento?"
  let text_eliminato =
    props.text_eliminato !== undefined ? props.text_eliminato : 'Elemento eliminato con successo'
  let text_nuovo = props.text_nuovo !== undefined ? props.text_nuovo : 'Nuovo elemento'
  const otherButtons = props.otherButtons !== undefined ? props.otherButtons : []
  const customMenuClicked = props.menuClicked !== undefined ? props.menuClicked : null
  const [filters, setFilters] = useState(_filters)
  const [filtersValues, setFiltersValues] = useState({})
  const [reloadData, setReloadData] = useState(0)
  const {library} = useCrud()
  const [items, setItems] = useState([])
  const [pagination, setPagination] = useState({})
  const [order, setOrder] = useState(defOrder)
  const [orderDir, setOrderDir] = useState(defOrderDir)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [redirect, setRedirect] = useState('')
  const [loaded, setLoaded] = useState(false)
  const [filterLoaded, setFilterLoaded] = useState(1)
  const title = props.title !== undefined ? props.title : ''
 

  useEffect(() => {
    const fetchData = async () => {
      let params = {
        order: order,
        order_direction: orderDir,
        search,
        per_page,
        page,
      }

      if (filtersValues) {
        for (let key in filtersValues) {
          params[key] = filtersValues[key]
        }
      }

      const response: any = await library?.list(params)
      setItems(response.data)
      setPagination(response.pagination)
      setLoaded(true)
      setTimeout(() => {
        MenuComponent.createInstances('[data-kt-menu-table="true"]')
      }, 100)
    }
   // setLoaded(false)
    console.log("filterLoaded", filterLoaded, "filters.length", filters.length)
   if(filterLoaded >= filters.length){
    fetchData()
   }
    
  }, [order, orderDir, search, reloadData, page, filterLoaded, filtersValues, filters,library,per_page])

  useEffect(() => {
    let _filtersValues = {}
    let _filters: any = []
    for (let f of filters) {
      if (_filtersValues[f.key] === undefined) {
        _filtersValues[f.key] = f.options?.defaultValue !== undefined ? f.options?.defaultValue : ''
      }
      console.log(f.type)
      if (f.type === 'ajaxselect') {
        const fetchData = async () => {
          setFilterLoaded(filterLoaded + 1)
          if (f.options) {
            const response: any = await library?.customList(f.options?.apiPath + '')
            f.options.data = response
            f.type = 'select'
          }
          _filters.push(f)
          setFilters(_filters)
          setFiltersValues(_filtersValues)
        }
        fetchData()
      }else{
        setFilterLoaded(filterLoaded + 1);
        _filters.push(f)
        setFilters(_filters)
        setFiltersValues(_filtersValues)
      }
     
    }
    
  }, [])

 

  const menuClicked = async (action, item) => {
    if (customMenuClicked) {
      let propagate = await customMenuClicked(action, item)
      if (!propagate) {
        return
      }
    }
    if (action === 'edit') {
      let id: string = item.id + ''
      setRedirect('./edit/' + id)
      console.log('edit')
    }
    if (action === 'delete') {
      deleteItem(item)
    }
  }

  const deleteItem = async (item) => {
    MySwal.fire({
      title: title_delete,
      text: text_eliminare,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sì, elimina',
      cancelButtonText: 'No, annulla',
    }).then(async (response: any) => {
      if (response.value) {
        let result:any = await library?.delete(item.id);
        if(result.success == 1){
          MySwal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer
              toast.onmouseleave = Swal.resumeTimer
            },
            icon: 'success',
            title: text_eliminato,
          })

          setReloadData(reloadData + 1)
        }else if(result.success === 0){
          if(result.code === "SHOW_DELETE_ERROR"){
            MySwal.fire({
              title: 'Errore',
              text: result.errorMsg,
              icon: 'error',
            }).then(() => {
              setReloadData(reloadData + 1)
            })
          }
          if(result.code === "DELETE_NOT_ALLOWED"){
            MySwal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 5500,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer
                toast.onmouseleave = Swal.resumeTimer
              },
              icon: 'error',
              title: result.errorMsg,
            })
          }
        }


      }
    })
  }
  const sortChange = (key) => {
    if (order === key) {
      if (orderDir === 'asc') {
        setOrderDir('desc')
      } else {
        setOrderDir('asc')
      }
    } else {
      setOrder(key)
      setOrderDir('asc')
    }
  }

  const getData = () => {
    return (
      <>
        <div className='card mb-5 mb-xl-10'>
          <div className='card-header border-0'>
            <div className='card-toolbar w-100'>
              <div className='d-flex justify-content-between w-100'>
                <div className='input-group' style={{width: '300px'}}>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Cerca...'
                    onKeyUp={(e) => {
                      setPage(1);
                      setSearch(e.currentTarget.value);
                    }}
                  />
                  <span className='input-group-text'>
                    <i className='fa fa-search text-muted'></i>
                  </span>
                </div>

                <div className='d-flex justify-content-end w-100'>
                  <DrawFilters
                    filters={filters}
                    changeFilter={(key, value) => {
                      filtersValues[key] = value
                      console.log(filtersValues)
                      setFiltersValues(filtersValues)
                      setReloadData(reloadData + 1)
                    }}
                  ></DrawFilters>
                  {newButton && (
                    <Link to={'./add'} className='btn btn-primary ms-2'>
                      <i className='fa-solid fa-circle-plus'></i> {text_nuovo}
                    </Link>
                  )}
                  {otherButtons.map((button, index) => (
                    <Link
                      to={button.to}
                      key={index}
                      className={clsx('btn', 'btn-' + button.color, 'ms-2')}
                    >
                      <i className={button.icon}></i> {button.title}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className='card-body border-top border-gray-500'>
            {title && <h5>{title}</h5>}
            <table className='table'>
              <thead>
                <tr className='text-start text-gray-700 fw-bold fs-7 text-uppercase'>
                  {columns.map((column: ColumnType) => (
                    <HeadRow
                      column={column}
                      key={column.key}
                      order={order}
                      orderDir={orderDir}
                      onSort={(key) => {
                        sortChange(key)
                      }}
                    ></HeadRow>
                  ))}

                  {show_menu && actions.length > 0 ? (
                    <th style={{width: '130px'}}>Azioni</th>
                  ) : (
                    <></>
                  )}
                </tr>
              </thead>
              <tbody>
                {items &&
                  items.map((item: any) => (
                    <tr key={item.id} className='odd'>
                      {columns.map((column: ColumnType) => {
                        let key = item.id + '-' + column.key
                        return <TableRow item={item} key={key} column={column}></TableRow>
                      })}

                      {show_menu && actions.filter((a)=>{return a.condition === undefined || a.condition(item)}).length > 0 ? (
                        <td>
                          <MenuActions
                            actions={actions.filter((a)=>{return a.condition === undefined || a.condition(item)})}
                            item={item}
                            menuClicked={(action, item) => {
                              menuClicked(action, item)
                            }}
                          ></MenuActions>{' '}
                        </td>
                      ) : (
                        <></>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
            <Pagination
              pagination={pagination}
              page={page}
              changePage={(page) => {
                setPage(page)
              }}
            ></Pagination>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      {redirect !== '' ? <Navigate to={redirect}></Navigate> : <></>}
      {!loaded ? (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-body border-top p-9'>
            <div>
              <div className='d-flex  flex-row justify-content-center align-items-center mb-5'>
                <i className='ki-duotone ki-chart fa-spin fs-1'>
                  <i className='path1'></i>
                  <i className='path2'></i>
                </i>{' '}
                Loading...
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loaded && getData()}
    </>
  )
})

const Pagination = ({pagination, page, changePage}) => {
  console.log(pagination)
  if (!pagination || pagination.pages === 0 || pagination.pages === 1) {
    return <></>
  }
  let start = page - 2
  let end = page + 2
  if (start < 1) {
    start = 1
  }

  if (end > pagination.pages) {
    end = pagination.pages
  }
  let pages: any = []
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }
  return (
    <>
      <ul className='pagination'>
        <li
          onClick={(e) => {
            if (page === 1) {
              return
            }
            changePage(page - 1)
          }}
          className={clsx('page-item previous', {disabled: page === 1})}
        >
          <a href='#' className='page-link'>
            <i className='previous'></i>
          </a>
        </li>
        {pages.map((p: any, index: number) => (
          <li
            key={index}
            onClick={(e) => {
              changePage(p)
            }}
            className={clsx('page-item', {active: p === page})}
          >
            <a href='#' className='page-link'>
              {p}
            </a>
          </li>
        ))}

        <li
          onClick={(e) => {
            if (page === pagination.pages) {
              return
            }
            changePage(page + 1)
          }}
          className={clsx('page-item previous', {disabled: page == pagination.pages})}
        >
          <a href='#' className='page-link'>
            <i className='next'></i>
          </a>
        </li>
      </ul>
    </>
  )
}

const DrawFilters = ({filters, changeFilter}) => {
  return (
    <>
      {filters.map((filter: FilterType, index: number) => (
        <DrawFilter
          filter={filter}
          key={index}
          changeFilter={(value) => {
            changeFilter(filter.key, value)
          }}
        ></DrawFilter>
      ))}
    </>
  )
}

const DrawFilter = ({filter, changeFilter}) => {
  if (filter.type === 'select') {
    return (
      <>
        <select
          className='form-select form-select-sm me-2'
          style={{width: '300px'}}
          onChange={(e) => {
            changeFilter(e.currentTarget.value)
          }}
        >
          {filter.options.addEmpty ? <option value=''>{filter.options.emptyLabel}</option> : <></>}
          {filter.options.data &&
            filter.options.data.map((option) => (
              <option
                key={option[filter.options.valueField]}
                value={option[filter.options.valueField]}
              >
                {option[filter.options.labelField]}
              </option>
            ))}
        </select>
      </>
    )
  }
  if (filter.type === 'date') {
    return (
      <>
        <div className='input-group' style={{width: '300px'}}>
          <div className='input-group-text'>{filter.title}</div>
          <input
            type='date'
            placeholder=''
            className='form-control form-control-sm me-2'
            onChange={(e) => {
              changeFilter(e.currentTarget.value)
            }}
          ></input>
        </div>
      </>
    )
  }
  return <></>
}

const MenuActions = ({actions, item, menuClicked}) => {
  return (
    <div className='m-0'>
      <a
        href='#'
        className='btn btn-sm btn-light btn-color-gray-700 btn-flex btn-center  fw-bold'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='bottom-end'
      >
        Azioni <i className='ki-duotone ki-down fs-5 ms-1'></i>
      </a>
      <div
        data-kt-menu-table='true'
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-250px pt-2 pb-2'
      >
        {actions.map((action: ActionType, index: number) => (
          <MenuAction
            action={action}
            item={item}
            key={index}
            menuClicked={(action, item) => {
              menuClicked(action, item)
            }}
          ></MenuAction>
        ))}
      </div>
    </div>
  )
}

const MenuAction = ({action, item, menuClicked}) => {
  if (action.type === 'divider') {
    return <div className='separator my-2'></div>
  }
  return (
    <>
      <div className='menu-item px-3'>
        <a
          href='#'
          onClick={() => {
            menuClicked(action.action, item)
          }}
          className={clsx(
            'menu-link  cursor-pointer',
            {'text-danger': action.textColor && action.textColor == 'danger'},
            {'text-warning': action.textColor && action.textColor == 'warning'},
            {'text-success': action.textColor && action.textColor == 'success'}
          )}
        >
          {action.icon ? (
            <span className='me-2'>
              <i
                className={clsx(
                  action.icon,
                  {'text-danger': action.textColor && action.textColor == 'danger'},
                  {'text-warning': action.textColor && action.textColor == 'warning'},
                  {'text-success': action.textColor && action.textColor == 'success'}
                )}
              ></i>
            </span>
          ) : (
            <></>
          )}
          {action.title}
        </a>
      </div>
    </>
  )
}
const HeadRow = ({column, order, orderDir, onSort}) => {
  const sort = (key) => {
    onSort(key)
  }
  if (column.orderable) {
    let style: any = column.style ?? {}
    style.cursor = 'pointer'
    return (
      <th
        onClick={(e) => {
          sort(column.key)
        }}
        style={style}
      >
        {column.title}
        &nbsp;
        {order === column.key && orderDir === 'asc' ? (
          <i className='fa-solid fa-arrow-down-long'></i>
        ) : (
          <></>
        )}
        &nbsp;
        {order === column.key && orderDir === 'desc' ? (
          <i className='fa-solid fa-arrow-up-long'></i>
        ) : (
          <></>
        )}
      </th>
    )
  }
  let style = column.style ?? {}
  console.log(style)
  return <th style={style}>{column.title}</th>
}
const TableRow = ({item, column}) => {
  if (item[column.key] === null || item[column.key] === '') {
    return <td></td>
  }
  if (column.type === 'text') {
    return <td>{item[column.key]}</td>
  }
  if (column.type === 'number') {
    return (
      <td>
        <NumericFormat
          displayType='text'
          value={item[column.key]}
          thousandSeparator='.'
          decimalSeparator=','
          decimalScale={
            column.options && column.options.decimalScale !== undefined
              ? column.options.decimalScale
              : 2
          }
          suffix={
            column.options && column.options.suffix !== undefined ? column.options.suffix : ''
          }
          prefix={
            column.options && column.options.prefix !== undefined ? column.options.prefix : ''
          }
        />
      </td>
    )
  }

  if (column.type === 'money') {
    return (
      <td>
        <NumericFormat
          displayType='text'
          value={item[column.key]}
          thousandSeparator='.'
          decimalSeparator=','
          decimalScale={2}
          fixedDecimalScale
          prefix={
            column.options && column.options.suffix !== undefined ? column.options.suffix : '€ '
          }
        />
      </td>
    )
  }
  if (column.type === 'date') {
    return (
      <td>
        {format(
          new Date(item[column.key]),
          column.options && column.options.date_format !== undefined
            ? column.options.date_format
            : 'dd/MM/yyyy'
        )}
      </td>
    )
  }

  if (column.type === 'datetime') {
    return (
      <td>
        {format(
          new Date(item[column.key]),
          column.options && column.options.date_format !== undefined
            ? column.options.date_format
            : 'dd/MM/yyyy HH:mm:ss'
        )}
      </td>
    )
  }

  if (column.type === 'custom') {
    return <td>{column.render(item)}</td>
  }

  if (column.type === 'boolean') {
    if (item[column.key] || item[column.key] === '1') {
      return (
        <td>
          <span className='badge badge-light-success'>Sì</span>
        </td>
      )
    } else {
      return (
        <td>
          <span className='badge badge-light-danger'>No</span>
        </td>
      )
    }
  }

  return <td>{item[column.key]}</td>
}
